export class SeasonInfo {
  id: number;
  active: boolean;
  seasonEnd: number | string;

  constructor(params: {
    id: number;
    active: boolean;
    seasonEnd: number | string;
  }) {
    this.id = params.id;
    this.active = params.active;
    this.seasonEnd = params.seasonEnd;
  }
}
